import { Box } from "@mantine/core";
import { useAtomValue } from "jotai";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { shadows } from "#app/theme/v2/shadows";
import { getSpacing, spacing } from "#app/theme/v2/spacing";

import { navbarCollapsedAtom } from "../Navbar/navbarAtom";

const NAVBAR_WIDTH_EXPANDED = `${getSpacing(58)}px`;
const NAVBAR_WIDTH_COLLAPSED = "0px";

type AppLayoutProps = {
  children?: React.ReactNode;
  leftSection?: React.ReactNode;
};

const AppLayout = ({ children, leftSection }: AppLayoutProps) => {
  const isCollapsed = useAtomValue(navbarCollapsedAtom);

  return (
    <Box
      style={{
        display: "flex",
        height: "100dvh",
        backgroundColor: colors.bg.elevation.secondary,
        gap: spacing[2],
        padding: spacing[2],
      }}
    >
      <Box
        style={{
          width: isCollapsed ? NAVBAR_WIDTH_COLLAPSED : NAVBAR_WIDTH_EXPANDED,
          flexShrink: 0,
          backgroundColor: colors.bg.elevation.secondary,
          borderRadius: radius.lg,
          overflow: "hidden",
          transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
        }}
      >
        <Box
          style={{
            height: "100%",
            opacity: isCollapsed ? 0 : 1,
            transition: "opacity 150ms",
            pointerEvents: isCollapsed ? "none" : undefined,
          }}
        >
          {leftSection}
        </Box>
      </Box>

      <Box
        style={{
          flex: 1,
          minWidth: 0,
          backgroundColor: colors.bg.elevation.primary,
          borderRadius: radius.lg,
          overflow: "hidden",
          boxShadow: shadows.xs,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export { AppLayout };
